import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    shareCode: window.sessionStorage.getItem('shareId'),
    account: window.sessionStorage.getItem('email'),
    token: window.sessionStorage.getItem('token'),
    _id: window.sessionStorage.getItem('_id'),
    path: window.sessionStorage.getItem('path'),
    allSoftName: null,
  },
  mutations: {
    getShareCode(state, info) {
      state.shareCode = info
    },
    getAccount(state, info) {
      state.account = info
    },
    getToken(state, info) {
      state.token = info
    },
    getAllSoftName(state, info){
      state.allSoftName = info
    }
  },
  actions: {
  },
  modules: {
  }
})
